import { Module } from "vuex";
import { RootState } from "../types";
import { InstructorState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: InstructorState = {};

const namespaced: boolean = true;

export const instructor: Module<InstructorState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
